import {ValueObject} from '@s-ui/domain'

export default class AdvertisementsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Object} deps.products
   * @param {String} deps.filteredProvinces
   */
  constructor({products, filteredProvinces = 'unknown'}) {
    super({products, filteredProvinces})
  }

  toJSON() {
    /* eslint-disable camelcase */
    return {
      products: this._products,
      filtered_provinces: this._filteredProvinces
    }
    /* eslint-enable camelcase */
  }

  getProducts() {
    return this._products
  }
}
